<la-button
  class="upgrade-button"
  appearance="outlined"
  icon="diamond"
  [disabled]="disabled"
  [buttonLink]="buttonLink"
  (click)="action.emit()"
>
  {{ text }}
</la-button>
